export default {
    InternalSalesOrderDetails: {
        aftersales: 'Create after-sales order',
        Delivery: 'Delivery Time',
        toCSGMANUAL: 'Change to CSG MANUAL',
        refund: 'Create refund order',
        return: 'Create return and refund order',
        Resend: 'Create Resend Order',
        Reissue: 'Create Reissue Order',
        Cancel: 'Cancel order',
        CancelSap: 'Cancel SAP order',
        Copy: 'Copy order',
        Confirm: 'Confirm receipt',
        Pending: 'Suspend',
        Unhook: 'Release',
        statistics: 'Order statistics',
        the: 'Completion status of all product lines under the order',
        Order: 'Status',
        Completed: 'Completed',
        Incomplete: 'Incomplete',
        Canceled: 'Canceled',
        not: 'Incomplete statistics',
        on: 'Status statistics for incomplete product lines',
        of: 'Out of stock',
        failed: 'Sourcing failed',
        be: 'To be shipped',
        Reservation: 'Successfully reserved, pending approval',
        Successful: 'Successfully sourced, pending approval',
        Pend: 'Pending',
        Abnormal: 'Abnormal status of product lines requiring manual processing',
        Out: 'Out of stock',
        Sourcing: 'Sourcing failed',
        approved: 'Pending approval',
        Pre: 'Preemptive write-back status',
        Shipment: 'Delivery write-back failed',
        Add: 'Add label',
        Basic: 'Account Information',
        type: 'Order Type',
        party: 'Customer Order No.',
        Internal: 'CSG Order No.',
        Store: 'Store',
        Three: '3rd Party Order Time',
        creation: 'Internal Creation Time',
        Buyer: 'Buyer Comments',
        Modify: 'Modify',
        History: 'View History',
        Comments: 'Comments',
        CommentsHistory: 'Comments History',
        Current: 'Current',
        Merchant: 'Customer Comments',
        Customer: 'CSG Comments',
        Receiving: 'Receiving information',
        nickname: 'Buyer nickname',
        Consignee: 'Full Name',
        Phone: 'Mobile',
        Address: 'Address',
        Amount: 'Amount information',
        FreiTotalght: 'Total product amount',
        payable: 'Total amount payable by buyer',
        cost: 'Total cost amount',
        information: 'Payment information',
        Payment: 'Payment method',
        status: 'Payment status',
        time: 'Payment time',
        actual: 'Buyer actual payment amount',
        Yuan: 'RMB',
        Invoice: 'Invoice information',
        View: 'View details',
        voice: 'Invoice type',
        header: 'Invoice title',
        content: 'Invoice content',
        invoicing: 'No invoicing application',
        Serial: 'Count',
        Document: 'Document number',
        Documenttype: 'Document type',
        StatusS: 'Status',
        Orderinformation: 'Order Information',
        Product: 'Product Information',
        Image: 'Image Information',
        Logistics: 'Logistics Information',
        internInfo: 'Internal Information',
        WarehouseRemarks: 'Warehouse Remarks',
        logisticsComment: 'Logistics Comment',
        Documentinformation: 'Document information',
        want: 'Kind reminder: Are you sure to perform this operation?',
        Operation: 'In operation, continue or not?',
        Create: 'Create refund order',
        Greturnoods: 'Create return order',
        returnAdd: 'Create return and refund order',
        delete: 'Delete this label?',
        error: 'Order information error: orderInfoVO.innerOrderNo=',
        sure: 'Confirm receipt?',
        Marking: 'Label',
        Pleaseselect: 'Please select',
        OrderAwaiting1: 'The order has been pushed to the warehouse or shipped, Please confirm cancellation',
        OrderAwaiting2: 'The order has been pushed to the warehouse or shipped, please contact customer service to cancel',
        cancelSAPFirst: 'Please confirm that SAP has been cancelled',
        orderShipped: 'Cancellation failed, order has been shipped',
        send: 'Send',
        customerDelivery: 'Pick Up',
        ReturnLabel: 'Return Label',
        errMsgText: 'The logistics information and shipping fee cannot be left blank!',
        shippingLabel: 'Shipping Documents',
        shippingLabelUpdate: 'Upload Documents',
        CourierLabelUpdate: 'Courier Label',
        closeOrderTip: 'Whether to close the order',
        closeOrder: 'Closed Orders',
        pickUpTime: 'Pick Up Time',
        shippingCost: 'Please confirm if the shipping cost is correct?',
        duplicateTrackingConfirm: 'Tracking number already exists. It may be a combined shipment. Please verify before adding.',
        duplicateTrackingBack: 'Back',
        duplicateTrackingVerified: 'Verified',
        PaymentInformation: 'Payment Information',
        PaymentInfo: 'Payment Info',
        CustomerName: 'Customer Name',
        PaymentStatus: 'Payment Status',
        PaymentId: 'Payment ID',
        InvoiceNo: 'Invoice No.',
        OrderDate: 'Order Date',
        InvoiceWeek: 'Invoice Week',
        PaymentTableNO: 'No.',
        PaymentTableItem: 'Item',
        PaymentTableQty: 'Qty',
        PaymentTablePrice: 'Unit Price',
        PaymentTableTotal: 'Total',
        PaymentTableSubTotal: 'Subtotal',
        PaymentTableGST: 'GST',
        PaymentTableSubTotalGST: 'Total(incl.GST)',
    }
};
